// @ts-nocheck
// Page: self-serve-find-solar-popup
// Ported from:
//   Enrollment_modules/self-serve/find-solar-popup.module/module.html (lines 61-1332)

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","init",[root,_config],["root","_config"]);
  const bind = (sel, type, fn) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  var responseFromAPI = ""

  /* loader function */
  function enterZipOpenLoader() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","enterZipOpenLoader",[],[]);
    var loader = document.getElementById("multienterZipLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("MEZloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function enterZipcloseLoader() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","enterZipcloseLoader",[],[]);
    var loader = document.getElementById("multienterZipLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("MEZloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  /* loader function */

  document.querySelector(".lfcsiya-main.findSolarPopup .crossButton img").onclick = (_event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[_event],["_event"]);
    hidePopup()
  }

  function hidePopup() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","hidePopup",[],[]);
    document.querySelector(".lfcsiya-main.findSolarPopup").style.display = "none"
  }

  /* validate input to just type number value */
  function validateNumericInput(input) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","validateNumericInput",[input],["input"]);
    // Remove non-numeric characters using a regular expression
    input.value = input.value.replace(/[^0-9]/g, "")
  }
  /* validate input to just type number value */
  var dealOwner = 0

  async function findSolar() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","findSolar",[],[]);
    enterZipOpenLoader()
    var _prevDealAttcode = storage.rawGet("gotAttCode")
    var localattcode = storage.rawGet("attcode")
    var attRepId = storage.rawGet("repid")
    if (localattcode == null) {
      var attcode = document.querySelector("#gsicode").value.trim()
      if (!attcode === "") {
        attcode = attcode.toUpperCase()
        const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.brokerAttribution}/rows?portalId=${window.__ENV__.dataPortalId}&attribution_code=${attcode}&default_broker_contact=1`
        fetch(hubDBEndpoint, {
          method: "GET",
        })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              var isFirstIteration = true
              rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[element],["element"]);
                if (isFirstIteration) {
                  isFirstIteration = false
                  repid = element.values["10"]
                  referralUrl = element.values["5"]
                  dealOwner = element.values["11"]
                  storage.rawSet("attcode", attcode)
                  storage.rawSet("repid", repid)
                  storage.rawSet("referralUrl", referralUrl)
                  var brokerRepPhoneNo = element.values["6"]
                  var brokerRepEmail = element.values["7"]
                  var brokerRepTitle = element.values["9"]
                  var brokerRepName = element.values["4"]
                  var brokerCompany = element.values["2"]
                  if (element.values["8"] !== undefined) {
                    var brokerRepImage = element.values["8"].url
                    storage.rawSet("brokerRepImage", brokerRepImage)
                  }
                  if (element.values["13"] !== undefined) {
                    var brokerMeetingUrl = element.values["13"].url
                    storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                  }
                  storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                  storage.rawSet("brokerRepEmail", brokerRepEmail)
                  storage.rawSet("brokerRepTitle", brokerRepTitle)
                  if (brokerRepName !== undefined) {
                    storage.rawSet("brokerRepName", brokerRepName)
                  }
                  storage.rawSet("brokerCompany", brokerCompany)
                  storage.rawSet("sidebarBrokerDisplay", "Yes")
                }
              })
            } else {
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      } else {
        storage.rawSet("sidebarBrokerDisplay", "No")
      }
    } else {
      localattcode = localattcode.toUpperCase()
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.brokerAttribution}/rows?portalId=${window.__ENV__.dataPortalId}&attribution_code=${localattcode}`
      fetch(hubDBEndpoint, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[data],["data"]);
          const rows = data.objects
          if (rows.length >= 1) {
            for (var i = 0; i < rows.length; i++) {
              const element = rows[i]
              if (element.values["5"].includes(attRepId) && element.values["5"].includes(localattcode)) {
                dealOwner = element.values["11"]
                var brokerRepPhoneNo = element.values["6"]
                var brokerRepEmail = element.values["7"]
                var brokerRepTitle = element.values["9"]
                var brokerRepName = element.values["4"]
                var brokerCompany = element.values["2"]
                if (element.values["8"] !== undefined) {
                  var brokerRepImage = element.values["8"].url
                  storage.rawSet("brokerRepImage", brokerRepImage)
                }
                if (element.values["13"] !== undefined) {
                  var brokerMeetingUrl = element.values["13"].url
                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                }
                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                storage.rawSet("brokerRepEmail", brokerRepEmail)
                storage.rawSet("brokerRepTitle", brokerRepTitle)
                if (brokerRepName !== undefined) {
                  storage.rawSet("brokerRepName", brokerRepName)
                }
                storage.rawSet("brokerCompany", brokerCompany)
                storage.rawSet("sidebarBrokerDisplay", "Yes")
                break
              } else {
                if (i === rows.length - 1) {
                  // Code to execute on the last iteration
                  for (var k = 0; k < rows.length; k++) {
                    const elementt = rows[k]
                    if (elementt.values["5"].includes(localattcode)) {
                      if (elementt.values["12"] === 1) {
                        dealOwner = elementt.values["11"]
                        repid = elementt.values["10"]
                        var brokerRepPhoneNo = elementt.values["6"]
                        var brokerRepEmail = elementt.values["7"]
                        var brokerRepTitle = elementt.values["9"]
                        var brokerRepName = elementt.values["4"]
                        var brokerCompany = elementt.values["2"]
                        if (elementt.values["8"] !== undefined) {
                          var brokerRepImage = elementt.values["8"].url
                          storage.rawSet("brokerRepImage", brokerRepImage)
                        }
                        if (elementt.values["13"] !== undefined) {
                          var brokerMeetingUrl = elementt.values["13"].url
                          storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                        }
                        storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                        storage.rawSet("brokerRepEmail", brokerRepEmail)
                        storage.rawSet("brokerRepTitle", brokerRepTitle)
                        if (brokerRepName !== undefined) {
                          storage.rawSet("brokerRepName", brokerRepName)
                        }
                        storage.rawSet("brokerCompany", brokerCompany)
                        storage.rawSet("sidebarBrokerDisplay", "Yes")
                        storage.rawSet("repid", repid)
                        break
                      } else {
                        if (k === rows.length - 1) {
                          storage.rawRemove("attcode")
                          storage.rawRemove("repid")
                          storage.rawSet("sidebarBrokerDisplay", "No")
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            storage.rawRemove("attcode")
            storage.rawRemove("repid")
            storage.rawSet("sidebarBrokerDisplay", "No")
          }
        })
    }

    /* list items getting removed on page load - multiple utility name/zip code */
    var utilitynameCardss = document.querySelector(".findSolarPopup #retailUtilities-main") // ul li div
    utilitynameCardss.style.display = "none" // display none ul div because on page load
    var listt = document.querySelector(".findSolarPopup #retailUtilities") // Get the ul element
    listt.innerHTML = "" // Remove all li elements inside the ul
    /* list items getting removed on page load - multiple utility name/zip code */

    const enteredZip = document.querySelector(".findSolarPopup #zipCode").value.trim() // Get the entered zip code
    if (enteredZip !== "") {
      // Check if the zip code is not empty
      var limit = 1000
      var offset = 0
      var allRows = []
      var zipcount = 0
      var _allFarmRows = []
      document.querySelector(".findSolarPopup #resultMessage").style.display = "none"
      checkZipCodeInHubDB(enteredZip) // Call a function to check the zip code in HubDB
    } else {
      // Clear result message if the zip code is empty
      document.querySelector(".findSolarPopup #resultMessage").style.display = "block"
      document.querySelector(".findSolarPopup #resultMessage").innerText = "Please enter a zip code."
    }

    // Function to check the zip code in HubDB
    function checkZipCodeInHubDB(zipCode) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","checkZipCodeInHubDB",[zipCode],["zipCode"]);
      //live site utility zip table id 15223653

      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.communitySolar}/rows?portalId=${window.__ENV__.dataPortalId}&limit=${limit}&offset=${offset}`
      fetch(hubDBEndpoint, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[data],["data"]);
          const matchingRows = data.objects.filter((row) => row.values[1] === zipCode)
          const rows = data.objects
          if (matchingRows.length >= 1) {
            allRows = allRows.concat(matchingRows)
          }
          if (rows.length === limit) {
            // There might be more rows, fetch the next page
            offset += limit
            return checkZipCodeInHubDB(enteredZip)
          }
          if (allRows.length >= 1) {
            for (var m = 0; m < allRows.length; m++) {
              const currentObject = allRows[m]
              const zipColId = 1 //zip code column id
              const RetailUtiColId = 4 // Retail utility column id

              const zip = currentObject.values[zipColId]
              const utilityDisplayName = currentObject.values[RetailUtiColId]
              const utility_id = currentObject.values[3] // utility id column id
              const county = currentObject.values[5]
              var newItem = document.createElement("li") // create li
              newItem.id = utility_id // create id for each li
              if (utilityDisplayName !== undefined) {
                newItem.textContent = utilityDisplayName
              } else {
                newItem.textContent = utility_id
              }
              var utilitynameCards = document.querySelector(".findSolarPopup #retailUtilities-main") // ul li div
              var list = document.querySelector(".findSolarPopup #retailUtilities") // ul
              list.appendChild(newItem) // append items to ul
              zipcount = ++zipcount // pre increament for set condition if multiple zip code
              if (zipcount > 1) {

                utilitynameCards.style.display = "block" // display block ul div because there are multiple zip code
                /* ------- Add active class click on utility name li ---------- */
                document.querySelector(".findSolarPopup #retailUtilities").addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
                  if (event.target.tagName === "LI") {
                    utilitynameCards.style.display = "none"
                    enterZipOpenLoader()
                    document.querySelectorAll(".findSolarPopup #retailUtilities li").forEach((item) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[item],["item"]);
                      item.classList.remove("active")
                    })
                    event.target.classList.add("active")
                    const activeLiId = document.querySelector(".findSolarPopup #retailUtilities li.active")
                    const activeLiIdd = activeLiId.id
                    const UtilityDisplayNameForSignUp = activeLiId.textContent
                    storage.rawSet("utility_Name", UtilityDisplayNameForSignUp)
                    storage.rawSet("utility_id", activeLiIdd)
                    storage.rawSet("zip_code", zipCode)
                    storage.rawSet("county", county)
                    checkUtilityIdInFarmTable(activeLiIdd)
                  }
                })
                /* ------- Add active class click on utility name li ---------- */
                enterZipcloseLoader()
              } else {
                if (m === allRows.length - 1) {
                  // let utilityId = storage.rawGet('utility_id');
                  storage.rawSet("utility_Name", utilityDisplayName)
                  storage.rawSet("utility_id", utility_id)
                  storage.rawSet("zip_code", zipCode)
                  storage.rawSet("county", county)
                  checkUtilityIdInFarmTable(utility_id)
                }
              }
            }
          } else {
            enterZipcloseLoader()
            alert("did not found zip code")
            return
          }
          return allRows
        })
        .catch((error) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[error],["error"]);
        })
    }
  }
  async function findSignSolar() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","findSignSolar",[],[]);
    enterZipOpenLoader()
    const select = document.getElementById("projectSelection")
    const selectedRowId = select.value
    const errorMsg = document.getElementById("selectError")

    if (!selectedRowId || selectedRowId === "please select") {
      errorMsg.textContent = "Please select a Solar Farm"
      errorMsg.style.display = "block"
      enterZipcloseLoader()
      return
    }

    // Clear error and continue
    errorMsg.textContent = ""
    errorMsg.style.display = "none"

    // Save selected row ID
    storage.rawSet("selectedSolarFarm", selectedRowId)

    try {
      // Fetch the row by ID
      const portalId = "{{ hub_id }}"
      const tableId = "15223639"
      const apiUrl = `https://api.hubapi.com/hubdb/api/v2/tables/${tableId}/rows/${selectedRowId}?portalId=${portalId}`

      const response = await fetch(apiUrl)
      const row = await response.json()

      if (row?.values) {
        const values = row.values
        // Store desired fields individually
        storage.rawSet("FarmStreetAddress1", values["3"] || "undefined")
        storage.rawSet("FarmStreetAddress2", values["13"] || "undefined")
        storage.rawSet("FarmCity", values["4"] || "undefined")
        storage.rawSet("FarmStateAbbreviation", values["5"] || "undefined")
        storage.rawSet("FarmName", values["7"] || "undefined")
        storage.rawSet("FarmID", values["1"] || "undefined")
        storage.rawSet("FarmPhoneNumber", values["23"] || "undefined")
        storage.rawSet("FarmLlcAddress1", values["24"] || "undefined")
        storage.rawSet("FarmLlcAddress2", values["25"] || "undefined")
        storage.rawSet("FarmLlcCity", values["26"] || "undefined")
        storage.rawSet("FarmLlcZip", values["27"] || "undefined")
        storage.rawSet("FarmEmail", values["28"] || "undefined")
        storage.rawSet("FarmProjectDescription", values["22"] || "undefined")
        storage.rawSet("FarmLlc", values["21"] || "undefined")
        storage.rawSet("FarmDisplayName", values["2"] || "undefined")
        storage.rawSet("FarmLMIDiscount", values["19"] || "undefined")
        storage.rawSet("FarmOpenDiscount", values["20"] || "undefined")

        await createDealRecord()
      } else {
        enterZipcloseLoader()
        console.warn("⚠️ No row found with ID:", selectedRowId)
      }
    } catch (error) {
      enterZipcloseLoader()
      console.error("❌ Error fetching row by ID:", error)
    }
  }

  async function checkLMICheckboxValue() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","checkLMICheckboxValue",[],[]);
    enterZipOpenLoader()
    var secondcheckbox = false
    secondcheckbox = document.querySelector("#eligibleForLMIInput")
    if (secondcheckbox.checked) {
      storage.rawSet("isLMI", "Yes")
    } else {
      storage.rawSet("isLMI", "No")
    }
    await createDealRecord()
  }

  var first_visited_url = storage.rawGet("first_visited_url")

  // Index Db Part
  var request = indexedDB.open("myDatabase", 1)
  var db
  request.onerror = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    db = event.target.result
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    var db = event.target.result

    // Create an object store (similar to a table in relational databases)
    var objectStore = db.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabase() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","clearDatabase",[],[]);
    var transaction = db.transaction(db.objectStoreNames, "readwrite")

    transaction.oncomplete = (_event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[_event],["_event"]);
    }

    transaction.onerror = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    }

    Array.from(db.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }

  /* lmi database removed */
  //index DB
  var requestlmi = indexedDB.open("LmiDatabase", 1)
  var dblmi

  requestlmi.onerror = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
  }
  requestlmi.onsuccess = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    dblmi = event.target.result
    clearDatabaselmi()
  }
  requestlmi.onupgradeneeded = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    var dblmi = event.target.result

    // Create an object store (similar to a table in relational databases)
    var objectStore = dblmi.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabaselmi() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","clearDatabaselmi",[],[]);
    var transactionlmi = dblmi.transaction(dblmi.objectStoreNames, "readwrite")

    transactionlmi.oncomplete = (_event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[_event],["_event"]);
    }

    transactionlmi.onerror = (event) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[event],["event"]);
    }

    Array.from(dblmi.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[storeName],["storeName"]);
      var objectStorelmi = transactionlmi.objectStore(storeName)
      objectStorelmi.clear()
    })
  }
  /* create deal record */
  async function createDealRecord() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","createDealRecord",[],[]);
    var emaill = storage.rawGet("logEmail")
    emaill = emaill.toLowerCase()
    var cntId = `New Enrollment - ${storage.rawGet("RecordId")}`
    var contactId = storage.rawGet("RecordId")
    var FarmStateAbbreviation = storage.rawGet("FarmStateAbbreviation")
    var dealStage = "157471033"
    if (FarmStateAbbreviation === "IL") {
      dealStage = "984278683"
    }
    if (FarmStateAbbreviation === "undefined") {
      FarmStateAbbreviation = ""
    }
    var zip_code = storage.rawGet("zip_code")
    var utId = storage.rawGet("utility_id")
    var utName = storage.rawGet("utility_Name")
    var county = storage.rawGet("county")
    var catchdata = ""
    try {
      const dataa = {
        properties: {
          deal_email_test: emaill,
          dealname: cntId,
          dealstage: dealStage,
          service_state_abbreviation: FarmStateAbbreviation,
          postal_code: zip_code,
          utility_id: utId,
          utility_name: utName,
          county: county,
        },
      }
      const response = await fetch(apiUrl("AddDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataa),
      })
      catchdata = dataa
      const dealResult = await response.json()
      responseFromAPI = JSON.stringify(dealResult)
      const dealId = dealResult.id
      if (response.status === 200) {
        storage.rawSet("dealId", dealId)
        await dealAssociateWithContact(contactId, dealId)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function getDataFromContactRecordAndSaveLocal(_dealId) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","getDataFromContactRecordAndSaveLocal",[_dealId],["_dealId"]);
    var email = storage.rawGet("logEmail")
    email = email.toLowerCase()
    //         storage.rawSet('dealId', email);
    var catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        //                 enterZipcloseLoader();
      } else if (dataa.message === "User Found") {
        var _log_referral_url = dataa.userValue.properties.referral_url
        var _log_attribution_code = dataa.userValue.properties.attribution_code
        var recordId = dataa.userValue.properties.hs_object_id
        var firstName = dataa.userValue.properties.firstname
        var lastName = dataa.userValue.properties.lastname
        var onboardToken = dataa.userValue.properties.bayou_onboarding_token
        var home_phone = dataa.userValue.properties.phone
        var cell_phone = dataa.userValue.properties.mobilephone
        var dateOfBirth = dataa.userValue.properties.date_of_birth
        var bayouContactId = dataa.userValue.properties.bayou_id
        var is_enrolled_for_bayou = dataa.userValue.properties.is_enrolled_for_bayou

        storage.rawSet("RecordId", recordId)
        storage.rawSet("LoggedName", `${firstName} ${lastName}`)
        storage.rawSet("FirstName", firstName)
        storage.rawSet("LastName", lastName)
        storage.rawSet("CompanyName", `${firstName}&${lastName}`)
        storage.rawSet("DateOfBirth", dateOfBirth)
        storage.rawSet("onboarding_token", onboardToken)
        storage.rawSet("bayou_contact_id", bayouContactId)
        storage.rawSet("BayouContactId", bayouContactId)
        storage.rawSet("CellPhone", cell_phone)
        storage.rawSet("HomePhone", home_phone)
        if (is_enrolled_for_bayou === "yes") {
          storage.rawSet("is_enrolled_for_bayou", "yes")
        }

        if (storage.rawGet("userEmail") !== email) {
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
        }
        var l_contactId = dataa.userValue.id
        storage.rawSet("contactId", l_contactId)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function dealAssociateWithContact(contactId, dealId) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","dealAssociateWithContact",[contactId,dealId],["contactId","dealId"]);
    var emailll = storage.rawGet("logEmail")
    emailll = emailll.toLowerCase()
    var catchdata = ""
    try {
      const dataaa = {
        inputs: [
          {
            from: {
              id: contactId,
            },
            to: {
              id: dealId,
            },
          },
        ],
      }
      const response = await fetch(apiUrl("DealAssociateWithContact"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataaa),
      })
      catchdata = dataaa
      if (response.status === 200) {
        var dlowner = storage.rawGet("dealOwner")
        if (dlowner != null) {
          dealOwner = dlowner
        }
        await getDataFromContactRecordAndSaveLocal(dealId)
        await addedConfigIdWithSomeDataSignUp(dealOwner, dealId)
        clearDatabase()
        clearDatabaselmi()
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function SaveSessionDetailsOnLocalStorageSignUp() {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","SaveSessionDetailsOnLocalStorageSignUp",[],[]);
    var exampleUtilityId = storage.rawGet("utility_id")
    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    if (rows.length >= 1) {
      storage.rawSet("Config ID", rows[0].id)
      rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("SessionDetails", JSON.stringify(element.values))
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
          storage.rawSet("UtilityRate", element.values["78"])
          storage.rawSet("SubSizingFactor", element.values["79"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("acSystemSize", element.values["82"])
          storage.rawSet("acKwh", element.values["84"])
        } else {
        }
      })
    }
  }
  async function addedConfigIdWithSomeDataSignUp(rep, dealId) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","addedConfigIdWithSomeDataSignUp",[rep,dealId],["rep","dealId"]);
    setTimeout(async () => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[],[]);
      if (rep === 0 || rep === "" || rep == null) {
        await SaveSessionDetailsOnLocalStorageSignUp()
        //         var email = storage.rawGet("userEmail");
        var email = storage.rawGet("logEmail")
        email = email.toLowerCase()
        var SessionLocalStorage = JSON.parse(storage.rawGet("SessionDetails"))
        var SessionConfigID = storage.rawGet("Config ID")
        var utility_id = storage.rawGet("utility_id")
        var utility_Name = ""
        var FarmName = storage.rawGet("FarmName")
        var FarmID = storage.rawGet("FarmID")
        var UserDevice = storage.rawGet("User Device")
        var BrowserName = storage.rawGet("Browser Name")
        var opratingSystem = storage.rawGet("Operating System")
        var upd_attcode = storage.rawGet("attcode")
        var upd_repid = storage.rawGet("repid")
        var upd_referralUrl = storage.rawGet("referralUrl")
        if (upd_attcode == null) {
          upd_attcode = ""
          upd_repid = ""
          upd_referralUrl = first_visited_url
        }
        var BillOption = SessionLocalStorage["40"]
        var utility_ext_id_1 = ""
        var utility_ext_id_1_system = ""
        var utility_ext_id_2 = ""
        var utility_ext_id_2_system = ""
        var utility_ext_id_3 = ""
        var utility_ext_id_3_system = ""
        if (SessionLocalStorage["6"]) {
          utility_Name = SessionLocalStorage["6"]
        }
        if (SessionLocalStorage["7"]) {
          utility_ext_id_1 = SessionLocalStorage["7"]
        }
        if (SessionLocalStorage["8"].name) {
          utility_ext_id_1_system = SessionLocalStorage["8"].name
        }
        if (SessionLocalStorage["9"]) {
          utility_ext_id_2 = SessionLocalStorage["9"]
        }
        if (SessionLocalStorage["10"]) {
          utility_ext_id_2_system = SessionLocalStorage["10"].name
        }
        if (SessionLocalStorage["11"]) {
          utility_ext_id_3 = SessionLocalStorage["11"]
        }
        if (SessionLocalStorage["12"]) {
          utility_ext_id_3_system = SessionLocalStorage["12"].name
        }
        if (upd_attcode === "undefined") {
          upd_attcode = ""
        }
        if (upd_repid === "undefined") {
          upd_repid = ""
        }
        if (upd_referralUrl === "undefined") {
          upd_referralUrl = first_visited_url
        }
        var catchdata = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              solar_farm_id: FarmID,
              solar_farm_name: FarmName,
              utility_name: utility_Name,
              utility_id: utility_id,
              session_config_id: SessionConfigID,
              bill_option: BillOption,
              ext_id_1: utility_ext_id_1,
              ext_id_1_system: utility_ext_id_1_system,
              ext_id_2: utility_ext_id_2,
              ext_id_2_system: utility_ext_id_2_system,
              ext_id_3: utility_ext_id_3,
              ext_id_3_system: utility_ext_id_3_system,
              user_agent: BrowserName,
              user_device: UserDevice,
              user_agent___operating_system: opratingSystem,
              attribution_code: upd_attcode,
              attribution_rep: upd_repid,
              referral_url: upd_referralUrl,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          enterZipcloseLoader()
          storage.rawSet("userEmail", email.toLowerCase())
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
          if (storage.rawGet("FarmStateAbbreviation") === "IL") {
            window.location.href = "/il-usage" // redirect to login page
          } else {
            window.location.href = "/my-info?mltenlmt" // redirect to login page
          }
          const result = await response.json()
        } catch (error) {
          console.error("Error:", error)
        }
        return true
      } else {
        await SaveSessionDetailsOnLocalStorageSignUp()
        //         var email = storage.rawGet("userEmail");
        var email = storage.rawGet("logEmail")
        email = email.toLowerCase()
        var SessionLocalStorage = JSON.parse(storage.rawGet("SessionDetails"))
        var SessionConfigID = storage.rawGet("Config ID")
        var utility_id = storage.rawGet("utility_id")
        var utility_Name = ""
        var FarmName = storage.rawGet("FarmName")
        var FarmID = storage.rawGet("FarmID")
        var UserDevice = storage.rawGet("User Device")
        var BrowserName = storage.rawGet("Browser Name")
        var opratingSystem = storage.rawGet("Operating System")
        var upd_attcode = storage.rawGet("attcode")
        var upd_repid = storage.rawGet("repid")
        var upd_referralUrl = storage.rawGet("referralUrl")
        if (upd_attcode == null) {
          upd_attcode = ""
          upd_repid = ""
          upd_referralUrl = first_visited_url
        } else {
          upd_referralUrl = first_visited_url
        }
        var BillOption = SessionLocalStorage["40"]
        var utility_ext_id_1 = ""
        var utility_ext_id_1_system = ""
        var utility_ext_id_2 = ""
        var utility_ext_id_2_system = ""
        var utility_ext_id_3 = ""
        var utility_ext_id_3_system = ""
        if (SessionLocalStorage["6"]) {
          utility_Name = SessionLocalStorage["6"]
        }
        if (SessionLocalStorage["7"]) {
          utility_ext_id_1 = SessionLocalStorage["7"]
        }
        if (SessionLocalStorage["8"].name) {
          utility_ext_id_1_system = SessionLocalStorage["8"].name
        }
        if (SessionLocalStorage["9"]) {
          utility_ext_id_2 = SessionLocalStorage["9"]
        }
        if (SessionLocalStorage["10"]) {
          utility_ext_id_2_system = SessionLocalStorage["10"].name
        }
        if (SessionLocalStorage["11"]) {
          utility_ext_id_3 = SessionLocalStorage["11"]
        }
        if (SessionLocalStorage["12"]) {
          utility_ext_id_3_system = SessionLocalStorage["12"].name
        }
        if (upd_attcode === "undefined") {
          upd_attcode = ""
        }
        if (upd_repid === "undefined") {
          upd_repid = ""
        }
        if (upd_referralUrl === "undefined") {
          upd_referralUrl = first_visited_url
        } else {
          upd_referralUrl = first_visited_url
        }
        var catchdata = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              solar_farm_id: FarmID,
              solar_farm_name: FarmName,
              utility_name: utility_Name,
              utility_id: utility_id,
              session_config_id: SessionConfigID,
              bill_option: BillOption,
              ext_id_1: utility_ext_id_1,
              ext_id_1_system: utility_ext_id_1_system,
              ext_id_2: utility_ext_id_2,
              ext_id_2_system: utility_ext_id_2_system,
              ext_id_3: utility_ext_id_3,
              ext_id_3_system: utility_ext_id_3_system,
              user_agent: BrowserName,
              user_device: UserDevice,
              user_agent___operating_system: opratingSystem,
              hubspot_owner_id: rep,
              attribution_code: upd_attcode,
              attribution_rep: upd_repid,
              referral_url: upd_referralUrl,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          enterZipcloseLoader()
          storage.rawSet("userEmail", email.toLowerCase())
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
          if (storage.rawGet("FarmStateAbbreviation") === "IL") {
            window.location.href = "/il-usage" // redirect to login page
          } else {
            window.location.href = "/my-info?mltenlmt" // redirect to login page
          }
          const result = await response.json()
        } catch (error) {
          console.error("Error:", error)
        }
        return true
      }
    }, 4000)
  }
  /* create deal record */

  /* Getting Address and Utility Name from Farm Table based on lowest priority */
  var _limitt = 1000
  var _offsett = 0
  var _allFarmRowss = []
  function checkUtilityIdInFarmTable(U_Id) {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","checkUtilityIdInFarmTable",[U_Id],["U_Id"]);
    //live farm table id 15223639
    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityFarm}/rows?portalId=${window.__ENV__.dataPortalId}&&utility_id=${U_Id}`
    fetch(hubDBEndpoint, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[data],["data"]);
        const rowss = data.objects
        const priorityArray = []
        var inc = 0
        for (var i = 0; i <= rowss.length; i++) {
          const currentobj = rowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          //                 if(FarmStateAbbreviation == "ME" || FarmStateAbbreviation == "CO" || FarmStateAbbreviation == "DE" || FarmStateAbbreviation == "NY" || FarmStateAbbreviation == "MD" || FarmStateAbbreviation == "IL" || FarmStateAbbreviation == "MN" ){
          ++inc
          const FarmZip = currentobj.values[6]
          const FarmName = currentobj.values[7]
          const FarmID = currentobj.values[1]
          const priority = currentobj.values[12]
          const FarmDisplayName = currentobj.values[2]
          const FarmStreetAddress1 = currentobj.values[3]
          const FarmStreetAddress2 = currentobj.values[13]
          const FarmCity = currentobj.values[4]
          const FarmEmail = currentobj.values[28]
          const FarmPhoneNumber = currentobj.values[23]
          const FarmProjectDescription = currentobj.values[22]
          const FarmLlc = currentobj.values[21]
          const FarmLMIDiscount = currentobj.values[19]
          const FarmOpenDiscount = currentobj.values[20]
          const FarmCounty = currentobj.values[35]
          var FarmPayment = ""
          if (currentobj.values[36] !== undefined && currentobj.values[36] !== "undefined") {
            FarmPayment = currentobj.values[36].name
          }
          const myObject = {
            FarmZip: FarmZip,
            FarmName: FarmName,
            FarmID: FarmID,
            priority: priority,
            FarmDisplayName: FarmDisplayName,
            FarmStreetAddress1: FarmStreetAddress1,
            FarmStreetAddress2: FarmStreetAddress2,
            FarmCity: FarmCity,
            FarmEmail: FarmEmail,
            FarmStateAbbreviation: FarmStateAbbreviation,
            FarmPhoneNumber: FarmPhoneNumber,
            FarmProjectDescription: FarmProjectDescription,
            FarmLlc: FarmLlc,
            FarmLMIDiscount: FarmLMIDiscount,
            FarmOpenDiscount: FarmOpenDiscount,
            FarmPayment: FarmPayment,
            FarmCounty: FarmCounty,
          }
          if (currentobj.values[9] === 1) {
            priorityArray.push(myObject)
          }
          //                 }
          if (i === rowss.length - 1) {
            if (priorityArray.length > 0) {
              document.querySelector(".eligibleForLMI").style.display = "none"

              if (FarmStateAbbreviation === "MN" && U_Id === "XCEL-SF") {
                document.querySelector(".eligibleForLMI").style.display = "none"
                const url = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id=XCEL-SF&project_selection=YES`

                fetch(url)
                  .then((response) => response.json())
                  .then((data) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[data],["data"]);
                    if (data.objects && data.objects.length > 0) {
                      const secondTableURL = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityFarm}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id=XCEL-SF&farm_enabled=true`

                      fetch(secondTableURL)
                        .then((response) => response.json())
                        .then((datas) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[datas],["datas"]);
                          const select = document.getElementById("projectSelection")

                          if (datas.objects && datas.objects.length > 0) {
                            datas.objects.forEach((row) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[row],["row"]);
                              const values = row.values
                              const displayName = values["2"] || ""
                              const street = values["3"] || ""
                              const city = values["4"] || ""
                              const zip = values["6"] || ""
                              const rowid = row.id
                              const optionText = `${displayName} - ${street} ${city} ${zip}`
                              const option = document.createElement("option")
                              option.value = rowid
                              option.textContent = optionText

                              select.appendChild(option)

                              // Hide element
                              const findSolarElement = document.querySelector(".lfcsiya-find-solar")
                              findSolarElement.style.display = "none"
                              const refCodeElement = document.querySelector(".referral-code")
                              refCodeElement.style.display = "none"
                              document.querySelector(".lfcsiya-find-project-selection").style.display = "flex"
                              document.querySelector(".zipCodeButton2").style.display = "block"
                              document.querySelector(".zipCodeButton").style.display = "none"

                              // Select the element
                              const headingElement = document.querySelector(".lfcsiya-title")

                              // Clear all existing content
                              headingElement.innerHTML = ""

                              // Create and insert the new <h1>
                              const h1Element = document.createElement("h2")
                              h1Element.textContent = "We have Solar in your area!"

                              headingElement.appendChild(h1Element)
                            })
                          }
                        })
                        .catch((error) => console.error("Error fetching solar farm rows:", error))
                    } else {
                    }
                  })
                  .catch((err) => console.error("Error fetching filtered HubDB rows:", err))
              }

              const minPriorityObject = priorityArray.reduce(
                (min, obj) => (obj.priority < min.priority ? obj : min),
                priorityArray[0],
              )

              storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
              storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
              storage.rawSet("FarmCity", minPriorityObject.FarmCity)
              storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
              storage.rawSet("FarmName", minPriorityObject.FarmName)
              storage.rawSet("FarmID", minPriorityObject.FarmID)
              storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
              storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
              storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
              storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
              storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
              storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
              storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
              storage.rawSet("FarmPayment", minPriorityObject.FarmPayment)
              storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)

              if (FarmStateAbbreviation === "IL") {
                const findSolarElement = document.querySelector(".lfcsiya-find-solar")
                findSolarElement.style.display = "none"
                const refCodeElement = document.querySelector(".referral-code")
                refCodeElement.style.display = "none"
                document.querySelector(".eligibleForLMI").style.display = "block"
                document.querySelector(".zipCodeButton3").style.display = "block"
                document.querySelector(".zipCodeButton").style.display = "none"
                enterZipcloseLoader()
              } else if (FarmStateAbbreviation === "MN" && U_Id === "XCEL-SF") {
                enterZipcloseLoader()
              } else {
                createDealRecord()
              }
              break
            } else {
              alert("Project not found for this Zip Code")
              window.location.href = "/account"
              break
            }
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }

  // ─── Re-bind inline handlers stripped from module.html ──────────────────────
  bind("#zipCode", "input", function () {
__ea_trace("modules/self-serve/self-serve-find-solar-popup.ts","(anon)",[],[]);
    validateNumericInput(this)
  })
  bind(".zipCodeButton button", "click", findSolar)
  bind(".zipCodeButton2 button", "click", findSignSolar)
  bind(".zipCodeButton3 button", "click", checkLMICheckboxValue)
}
